import React from "react";
import ClipartElement from "./ClipartElement";
import "./SearchResults.css";

const SearchResults = ({
  searchValue,
  cliparts,
  categoriesList,
  layerId,
  selectedClipartId,
  setSelectedClipartId,
  onChooseClipart,
  defaultImageSize,
  showAll,
  user,
}) => {
  const newSearchValue = searchValue
    ? searchValue.replace(/\b\w/g, (l) => l.toLowerCase())
    : searchValue;

  const sortedClipart = cliparts.sort((a, b) => {
    return a.display_weight - b.display_weight;
  });

  // Filter out clipart that is set to only display for specified users, defined on the clipart category ()
  let userSortedClipart = sortedClipart.filter(function (clipart) {
    return clipart.categories.every(function (category) {
      let categoryData = categoriesList.find(({ value }) => value == category);

      if (categoryData && categoryData.userId.length > 0){
        return categoryData.userId.indexOf(user.id.toString()) > -1;
      }
      return true
    });
  });

  // Show clipart filtered by the wedding category on initial render, if searchValue isn't set
  const weddingClipart = userSortedClipart.filter(function (clipart) {
    return clipart.categories.some(function (category) {
      return category.indexOf(629) > -1;
    });
  });

  let filteredClipart = userSortedClipart.filter(function (clipart) {
    return clipart.categories.some(function (category) {
      return category.indexOf(newSearchValue) > -1;
    });
  });

  if (!filteredClipart.length) {
    filteredClipart = userSortedClipart.filter(function (clipart) {
      return clipart.keywords.some(function (category) {
        return category.toLowerCase().indexOf(newSearchValue) > -1;
      });
    });
  }

  // Show all clipart if no categories selected
  let clipartList = weddingClipart.map((clipart) => {
    return (
      <ClipartElement
        key={clipart.id}
        clipart={clipart}
        layerId={layerId}
        selectedClipartId={selectedClipartId}
        onChooseClipart={onChooseClipart}
        setSelectedClipartId={setSelectedClipartId}
        defaultImageSize={defaultImageSize}
      />
    );
  });

  // Show only clipart in the selected category
  if (searchValue) {
    clipartList = filteredClipart.map((clipart) => {
      if (clipart.url) {
        return (
          <ClipartElement
            key={clipart.id}
            clipart={clipart}
            layerId={layerId}
            selectedClipartId={selectedClipartId}
            onChooseClipart={onChooseClipart}
            setSelectedClipartId={setSelectedClipartId}
            defaultImageSize={defaultImageSize}
          />
        );
      } else {
        return null;
      }
    });
  }

  if (showAll) {
    clipartList = userSortedClipart.map((clipart) => {
      if (clipart.url) {
        return (
          <ClipartElement
            key={clipart.id}
            clipart={clipart}
            layerId={layerId}
            selectedClipartId={selectedClipartId}
            onChooseClipart={onChooseClipart}
            setSelectedClipartId={setSelectedClipartId}
            defaultImageSize={defaultImageSize}
          />
        );
      } else {
        return null;
      }
    });
  }

  return <div className="clipart">{clipartList}</div>;
};

export default SearchResults;
